module.exports = __webpack_public_path__ + "img/poly-2.b253677c.png";